(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-lookbook-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-lookbook-track]');
    var slides = root.querySelectorAll('[data-lookbook-slide]');
    var dotsWrap = root.querySelector('[data-lookbook-dots]');
    var total = slides.length;
    if (!track || total === 0) return;
    var index = 0;
    var loop = root.getAttribute('data-loop') === 'true';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduce && total > 1;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var timer = null;
    var dots = [];

    if (dotsWrap) {
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.className = 'lookbook-carousel__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (i) { dot.addEventListener('click', function () { go(i); restart(); }); })(i);
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    function render() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }
    function go(i) {
      if (i < 0) i = loop ? total - 1 : 0;
      if (i > total - 1) i = loop ? 0 : total - 1;
      index = i; render();
    }
    function next() { go(loop || index < total - 1 ? index + 1 : index); }
    function prev() { go(loop || index > 0 ? index - 1 : index); }
    function start() { if (autoplay) timer = setInterval(next, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    var prevBtn = root.querySelector('[data-lookbook-prev]');
    var nextBtn = root.querySelector('[data-lookbook-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    render();
    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-product-single-media-group]').forEach(function (group) {
      var prevBtn = group.querySelector('[data-gallery-prev]');
      var nextBtn = group.querySelector('[data-gallery-next]');
      if (!prevBtn && !nextBtn) return;

      function wrappers() {
        return Array.prototype.slice.call(group.querySelectorAll('[data-product-single-media-wrapper]'));
      }

      function go(dir) {
        var all = wrappers();
        if (all.length < 2) return;
        var visible = group.querySelector('[data-product-single-media-wrapper]:not(.hide)');
        var idx = all.indexOf(visible);
        if (idx === -1) idx = 0;
        var target = (idx + dir + all.length) % all.length;
        var mediaId = all[target].getAttribute('data-media-id');
        var thumb = group.querySelector("[data-thumbnail-id='" + mediaId + "']");
        if (thumb) thumb.click();
      }

      if (prevBtn)
        prevBtn.addEventListener('click', function () {
          go(-1);
        });
      if (nextBtn)
        nextBtn.addEventListener('click', function () {
          go(1);
        });

      // Mobile thumbnail-slider page dots (mirrors theme.js slideshow state).
      var dotsWrap = group.querySelector('[data-gallery-dots]');
      var slides = Array.prototype.slice.call(group.querySelectorAll('[data-slider-item]'));
      var perPage = 3;
      var pageCount = Math.ceil(slides.length / perPage);
      if (dotsWrap && pageCount > 1) {
        var dots = [];
        for (var p = 0; p < pageCount; p++) {
          var dot = document.createElement('span');
          dot.className = 'product-gallery__dot';
          dotsWrap.appendChild(dot);
          dots.push(dot);
        }

        var currentPage = function () {
          var minIndex = -1;
          slides.forEach(function (slide, i) {
            if (!slide.classList.contains('slick-active')) return;
            var si = parseInt(slide.getAttribute('data-slider-slide-index'), 10);
            if (isNaN(si)) si = i;
            if (minIndex === -1 || si < minIndex) minIndex = si;
          });
          if (minIndex === -1) return 0;
          return Math.min(Math.floor(minIndex / perPage), pageCount - 1);
        };

        var renderDots = function () {
          var page = currentPage();
          dots.forEach(function (d, i) {
            d.setAttribute('aria-current', i === page ? 'true' : 'false');
          });
        };

        renderDots();

        var observer = new MutationObserver(renderDots);
        slides.forEach(function (slide) {
          observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
